import storeInstance from '../store/instance'
import { RequestMiddleware, ResponseMiddleware } from './types'

export const requestMiddlewares: RequestMiddleware[] = [
  request => {
    const accessToken = storeInstance.get().authStore.token

    if (accessToken) {
      request.headers = { Authorization: `Bearer ${accessToken}` }
    }
    return request
  },
]

export const responseMiddlewares: ResponseMiddleware[] = []
